// import { library, icon } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Import Styling
// import style from "./icon-fa.module.scss";

// import { faCamera } from "@fortawesome/free-solid-svg-icons";
// library.add(faCamera);
//const camera = icon({ prefix: "fas", iconName: "camera" });

import {
  faMagnifyingGlass,
  faClose,
  faBars,
  faChevronDown,
  faCirclePlay,
} from "@fortawesome/pro-solid-svg-icons";

// import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF";
// import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
// import { faInstagram as ig } from "@fortawesome/free-brands-svg-icons/faInstagram";
// import { faYoutube as yt } from "@fortawesome/free-brands-svg-icons/faYoutube";
// import { faTiktok as tt } from "@fortawesome/free-brands-svg-icons/faTiktok";
// import { faApple } from "@fortawesome/free-brands-svg-icons/faApple";
import {
  faFacebookF as fb,
  // faTwitter as twt,
  faXTwitter as x,
  faInstagram as ig,
  faYoutube as yt,
  faTiktok as tt,
} from "@fortawesome/free-brands-svg-icons";

// Light Icons
import {
  faCircleInfo as infoCircle,
  faArrowRightToBracket as arrowBracket,
  faCheckCircle as checkCircle,
  faStarCircle as starCircle,
  faClose as thinX,
  faGlobe as globe,
  faFlagUsa as usa,
} from "@fortawesome/pro-light-svg-icons";

import { faArrowRight } from "@fortawesome/sharp-solid-svg-icons/faArrowRight";
// import { faChevronDown } from "@fortawesome/pro-light-svg-icons/faChevronDown";
// import { faChevronLeft } from "@fortawesome/pro-light-svg-icons/faChevronLeft";

export default function IconFA({
  name = "faClose",
  size = "1x",
  color = "black",
}) {
  const icons = {
    faMagnifyingGlass,
    faClose,
    faBars,
    faChevronDown,
    faCirclePlay,
    fb, // faFacebookF,
    // twt, // faTwitter,
    x, // faXTwitter,
    ig, // faInstagram,
    yt, // faYoutube,
    tt, // faTiktok,
    // faApple,
    infoCircle,
    arrowBracket,
    checkCircle,
    starCircle,
    faArrowRight,
    thinX,
    globe,
    usa,
  };

  return <FontAwesomeIcon icon={icons[name]} size={size} color={color} />;
}
